import { render, staticRenderFns } from "./ArgonQuickViewModal.vue?vue&type=template&id=fb9ef51a&scoped=true&"
import script from "./ArgonQuickViewModal.vue?vue&type=script&lang=js&"
export * from "./ArgonQuickViewModal.vue?vue&type=script&lang=js&"
import style0 from "./ArgonQuickViewModal.vue?vue&type=style&index=0&id=fb9ef51a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9ef51a",
  null
  
)

export default component.exports